import { LandingPage } from "@/modules/landing-page/LandingPage";
import { getLandingLayout } from "@/modules/navigation/website-layout/LandingLayout";
import { NextPageWithLayout } from "./_app";

const Index: NextPageWithLayout = () => {
  return <LandingPage />;
};

Index.getLayout = getLandingLayout;

export default Index;
